import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import ComponentCategorySave from "./ComponentCategorySave";


const ComponentCategoryEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const [componentCategory, setComponentCategory] = useState({});

    let response42 = useInvoke("WebApps", "42", {"@ComponentCategoryId": id});
    
    useEffect(() => {

        //get component category data
        if (response42.data.payload != undefined) {
            let data = JSON.parse(response42.data.payload).data[0];

            setComponentCategory(
                {
                    ComponentCategoryId: data[0],
                    CategoryName: data[1],
                    categorydescription: data[2],
                    CreatedDate: data[3]
                }
            );
        }

    }, [response42.isPending]);

    const handleFormSubmit = (e) => {

        let componentcategoryid = id;

        let valid = true;

        let categoryname = "";
        if (document.getElementById("categoryname").value != "") {
            categoryname = document.getElementById("categoryname").value;
        }
        else {
            categoryname = document.getElementById("categoryname").defaultValue;
        }

        let categorydescription = "";
        if (document.getElementById("categorydescription").value != "") {
            categorydescription = document.getElementById("categorydescription").value;
        }
        else {
            categorydescription = document.getElementById("categorydescription").defaultValue;
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            ComponentCategorySave(componentcategoryid, categoryname, categorydescription, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/ComponentCategory");
        }
    };

    document.title = "Component Categories - Edit";
    return ( 
        <div className="componentCategoryEdit">

            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>Edit Component Category</h2>

                        <form id="componentCategoryForm" noValidate="novalidate" autoComplete="off">  

                            <div className="form-group">
                                <label for="componentCategory">Category Name</label>
                                <input className="form-control" id="categoryname" name="categoryname" type="text" defaultValue={componentCategory["CategoryName"]} autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label for="componentDescription">Category Description</label>
                                <input className="form-control" id="categorydescription" name="categorydescription" type="text" defaultValue={componentCategory["categorydescription"]} autoComplete="off" />
                            </div>

                        </form>
                        <Link to="/ComponentCategory" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                            
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default ComponentCategoryEdit;